import { render, staticRenderFns } from "./index.page.vue?vue&type=template&id=e47a8b7c&scoped=true&"
import script from "./index.page.vue?vue&type=script&lang=ts&"
export * from "./index.page.vue?vue&type=script&lang=ts&"
import style0 from "./index.page.vue?vue&type=style&index=0&id=e47a8b7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e47a8b7c",
  null
  
)

export default component.exports
import QPageSticky from 'quasar/src/components/page-sticky/QPageSticky.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import QSpinnerOval from 'quasar/src/components/spinner/QSpinnerOval.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QPageSticky,QCard,QCardSection,QSkeleton,QSpinnerOval,QBtn});
